export enum InAppNotificationType {
    Tasks = 1,
    TaskAssignedToMe = 2,
    TaskAssignedToMeEdited = 3,
    TaskAssignedToMeInProgress = 4,
    TaskAssignedToMeCompleted = 5,
    TaskCreatedByMeInProgress = 6,
    TaskCreatedByMeOverdue = 7,
    TaskCreatedByMeEdited = 8,
    TaskCreatedByMeCompleted = 9,
    Tickets = 20,
    AMLiveList = 100,
    AMLiveListCandidateDecline = 101,
    Jobs = 200,
    JobsActionCompleted = 201,
    JobsActionCreated = 202,
    JobsActionSkipped = 203,
    JobsCustomActionCompleted = 204,
    JobsCustomActionCreated = 205,
    JobsCustomActionSkipped = 206,
    Compliance = 300,
    ComplianceLabOrderTicketStatusChanged = 301
}
